const { createConstant } = require('../helpers')

const service = 'partner-service'

module.exports = {
  // for admin panel
  GET_PARTNER_LIST: createConstant(service, 'GET_PARTNER_LIST'),
  GET_PARTNER_LIST_SUCCESS: createConstant(service, 'GET_PARTNER_LIST_SUCCESS'),
  GET_PARTNER_LIST_ERROR: createConstant(service, 'GET_PARTNER_LIST_ERROR'),
  GET_PARTNER_LIST_RESET: createConstant(service, 'GET_PARTNER_LIST_RESET'),

  // for admin panel
  GET_PARTNER: createConstant(service, 'GET_PARTNER'),
  GET_PARTNER_SUCCESS: createConstant(service, 'GET_PARTNER_SUCCESS'),
  GET_PARTNER_ERROR: createConstant(service, 'GET_PARTNER_ERROR'),
  GET_PARTNER_RESET: createConstant(service, 'GET_PARTNER_RESET'),

  // for admin panel
  CREATE_PARTNER: createConstant(service, 'CREATE_PARTNER'),
  CREATE_PARTNER_SUCCESS: createConstant(service, 'CREATE_PARTNER_SUCCESS'),
  CREATE_PARTNER_ERROR: createConstant(service, 'CREATE_PARTNER_ERROR'),
  CREATE_PARTNER_RESET: createConstant(service, 'CREATE_PARTNER_RESET'),

  // for admin panel
  UPDATE_PARTNER: createConstant(service, 'UPDATE_PARTNER'),
  UPDATE_PARTNER_SUCCESS: createConstant(service, 'UPDATE_PARTNER_SUCCESS'),
  UPDATE_PARTNER_ERROR: createConstant(service, 'UPDATE_PARTNER_ERROR'),
  UPDATE_PARTNER_RESET: createConstant(service, 'UPDATE_PARTNER_RESET'),

  // for admin panel
  DELETE_PARTNER: createConstant(service, 'DELETE_PARTNER'),
  DELETE_PARTNER_SUCCESS: createConstant(service, 'DELETE_PARTNER_SUCCESS'),
  DELETE_PARTNER_ERROR: createConstant(service, 'DELETE_PARTNER_ERROR'),
  DELETE_PARTNER_RESET: createConstant(service, 'DELETE_PARTNER_RESET'),

  // for doctor/patient app
  GET_PARTNER_DATA: createConstant(service, 'GET_PARTNER_DATA'),
  GET_PARTNER_DATA_SUCCESS: createConstant(service, 'GET_PARTNER_DATA_SUCCESS'),
  GET_PARTNER_DATA_ERROR: createConstant(service, 'GET_PARTNER_DATA_ERROR'),
  GET_PARTNER_DATA_RESET: createConstant(service, 'GET_PARTNER_DATA_RESET'),

}
